import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import {
  BLOCK_CONTAINER_ICON,
  CONST_SITE_LABEL,
  EBS_SNAPSHOT_DURATION,
  setScopedItem,
  STORAGE_KEYS,
  SUBSCRIPTION_STATUS,
  TRIAL_SUBSCRIPTION_DATA_LIMIT,
  useCurrentInstanceType,
} from './common/Helper';
import { useLocation, useNavigate } from 'react-router-dom';
import DebugService from '../services/DebugService';
import OptimizationService from '../services/OptimizationService';
import TableLoader from './common/contentloader/TableLoader';
import DataGridTable from './common/DataGridTable';
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import APIConstants from '../services/APIConstants';
import { useAuth } from '../state/AuthContext';
import { Button, Tab, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Chip } from '@mui/material';
import DashboardService from '../services/DashboardService';
import { BlockContainer } from './common/BlockContainer';
import SubscriptionApiService from '../services/SubscriptionApiService';
import InventoryApiService from '../services/InventoryApiService';
import SnackbarNotification, { SNACKBAR_THEME } from './common/SnackbarNotification';
import ConfirmModal from './common/ConfirmModal';
import { useScopedLocalStorage } from '../hooks/useScopedLocalStorage';
import { TabContext, TabList, TabPanel } from '@mui/lab';

export default function Optimization() {

  const [showTableTooltip, setShowTableTooltip] = useState(true)
  const [tableColumnList, setTableColumnList] = useState([])
  const [tableRowList, setTableRowList] = useState([])
  const [tableColumnListCustom, setTableColumnListCustom] = useState([])
  const [tableRowListCustom, setTableRowListCustom] = useState([])
  const [customTableMasterData, setCustomTableMasterData] = useState([])
  const [tableColumnListCombined, setTableColumnListCombined] = useState([])
  const [tableRowListCombined, setTableRowListCombined] = useState([])
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingCustom, setIsLoadingCustom] = React.useState(false);
  const [isLoadingCombined, setIsLoadingCombined] = React.useState(false);
  // const [hideTableData, setHideTableData] = React.useState(false);
  const [totalAWSCost, setTotalAWSCost] = React.useState(0);
  const [totalAWSRecommendedCost, setTotalAWSRecommendedCost] = React.useState(0);
  const [totalAWSSaving, setTotalAWSSaving] = React.useState(0);
  const [totalCustomCost, setTotalCustomCost] = React.useState(0);
  const [totalCustomRecommendedCost, setTotalCustomRecommendedCost] = React.useState(0);
  const [totalCustomSaving, setTotalCustomSaving] = React.useState(0);
  const [totalCombinedCost, setTotalCombinedCost] = React.useState(0);
  const [totalCombinedRecommendedCost, setTotalCombinedRecommendedCost] = React.useState(0);
  const [totalCombinedSaving, setTotalCombinedSaving] = React.useState(0);
  const [ebsTotalAvailable, setEBSTotalAvailable] = React.useState(0);
  const [s3TotalStorage, setS3TotalStorage] = React.useState('');
  const [s3TotalObjects, setS3TotalObjects] = React.useState('');
  const [s3AverageObjectSize, setS3AverageObjectSize] = React.useState('');
  const [asgHealthyCount, setASGHealthyCount] = React.useState('');
  const [asgUnhealthyCount, setASGUnhealthyCount] = React.useState('');
  const [asgRecommendedSaving, setASGRecommendedSaving] = React.useState('');
  const [asgHealthyCountAWS, setASGHealthyCountAWS] = React.useState('');
  const [asgUnhealthyCountAWS, setASGUnhealthyCountAWS] = React.useState('');
  const [asgRecommendedSavingAWS, setASGRecommendedSavingAWS] = React.useState('');
  const [ebsSnapshot1Cost, setEBSSnapshot1Cost] = React.useState('');
  const [ebsSnapshot2Cost, setEBSSnapshot2Cost] = React.useState('');
  const [ebsSnapshot3Cost, setEBSSnapshot3Cost] = React.useState('');
  const [ebsSnapshotTotalCost, setEBSSnapshotTotalCost] = React.useState('');
  // const [showSubscribeOverlay, setShowSubscribeOverlay] = React.useState(false);
  const [defaultHideColumns, setDefaultHideColumns] = React.useState({});
  const [snackbarMessage, setSnackbarMessage] = useState(null)
  const [snackbarStatus, setSnackbarStatus] = useState(null)
  const [showActivateNowConfirmModal, setShowActivateNowConfirmModal] = useState(false)
  const [blockContainersLabel, setBlockContainersLabel] = useState({})
  const [selectedTab, setSelectedTab] = useState(null)
  const [tagList, setTagList] = useState([])
  const [filterList, setFilterList] = useState({ tag: '', values: [] })
  const [totalPriceValueAWS, setTotalPriceValueAWS] = useState([])
  const [totalPriceValueCustom, setTotalPriceValueCustom] = useState([])
  const [totalPriceValueCombined, setTotalPriceValueCombined] = useState([])

  const location = useLocation()
  const { type } = useCurrentInstanceType()
  const navigate = useNavigate()

  const {
    isSubscriptionActive,
    loadingUserDetails,
    userDetails,
    refetchUserDetails,
    selectedAccount
  } = useAuth()

  const { getScopedItem } = useScopedLocalStorage()

  /**
   * @description 
   * 1. To set selectedTab based on the current instance type
   * 2. Reset Filter
   */
  useEffect(() => {
    if (['ec2', 'ebs', 'rds'].includes(type?.toLocaleLowerCase())) {
      setSelectedTab('combined')
    } else if (type?.toLocaleLowerCase() === 's3') {
      setSelectedTab('aws')
    } else {
      setSelectedTab('custom')
    }

    setFilterList({ tag: '', values: [] })
    fetchOptimizationTagList()
  }, [type]);

  /**
   * @description Calculate block labels and values
   */
  useEffect(() => {
    setBlockContainersLabel({
      block1Label: '',
      block1Value: '',
      block1Unit: '',
      block1Icon: '',
      block1ShowActionLink: 'HIDE',

      block2Label: '',
      block2Value: '',
      block2Unit: '',
      block2Icon: '',
      block2ShowActionLink: 'HIDE',

      block3Label: '',
      block3Value: '',
      block3Unit: '',
      block3Icon: '',
      block3ShowActionLink: 'HIDE',

      block4Label: '',
      block4Value: '',
      block4Unit: '',
      block4Icon: '',
      block4ShowActionLink: 'HIDE',
    })

    // Set block values for ebs
    if (type.toLocaleLowerCase() === 'ebs') {
      setBlockContainersLabel(prev => ({
        ...prev,

        block1Label: 'Total Cost',
        block1Value: selectedTab === 'combined' ? totalCombinedCost : (selectedTab === 'custom' ? totalCustomCost : totalAWSCost),
        block1Unit: '$',
        block1Icon: BLOCK_CONTAINER_ICON.SAVING,

        block2Label: 'Total Recommended Saving Cost',
        block2Value: selectedTab === 'combined' ? totalCombinedSaving : (selectedTab === 'custom' ? totalCustomSaving : totalAWSSaving),
        block2Unit: '$',
        block2Icon: BLOCK_CONTAINER_ICON.SAVING,

        block3Label: 'Total Payable',
        block3Value: selectedTab === 'combined' ? totalCombinedRecommendedCost : (selectedTab === 'custom' ? totalCustomRecommendedCost : totalAWSRecommendedCost),
        block3Unit: '$',
        block3Icon: BLOCK_CONTAINER_ICON.SAVING,

        block4Label: 'Total EBS Available',
        block4Unit: '',
        block4Value: `${ebsTotalAvailable} GB`,
        block4Icon: BLOCK_CONTAINER_ICON.BUCKET,
      }))

      // Set block values for S3
    } else if (type.toLocaleLowerCase() === 's3') {
      setBlockContainersLabel(prev => ({
        ...prev,

        block1Label: 'Total Storage',
        block1Value: s3TotalStorage,
        block1Icon: BLOCK_CONTAINER_ICON.BUCKET,

        block2Label: 'Total objects',
        block2Value: s3TotalObjects,
        block2Icon: BLOCK_CONTAINER_ICON.BUCKET,

        block3Label: 'Average Object Size',
        block3Value: s3AverageObjectSize,
        block3Icon: BLOCK_CONTAINER_ICON.BUCKET,
      }))

      // Set block values for ASG
    } else if (type.toLocaleLowerCase() === 'asg') {
      setBlockContainersLabel(prev => ({
        ...prev,

        block1Label: 'Total Healthy Count',
        block1Value: selectedTab === 'aws' ? asgHealthyCountAWS : asgHealthyCount,
        block1Icon: BLOCK_CONTAINER_ICON.SAVING,

        block2Label: 'Total Unhealthy Count',
        block2Value: selectedTab === 'aws' ? asgUnhealthyCountAWS : asgUnhealthyCount,
        block2Icon: BLOCK_CONTAINER_ICON.SAVING,

        block3Label: 'Total Recommended Saving Cost',
        block3Value: selectedTab === 'aws' ? asgRecommendedSavingAWS : asgRecommendedSaving,
        block3Icon: BLOCK_CONTAINER_ICON.SAVING,
      }))

      // Set block values for SNAPSHOT
    } else if (['ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase())) {
      setBlockContainersLabel(prev => ({
        ...prev,

        block1Label: `${EBS_SNAPSHOT_DURATION.ZERO_TO_SIX_MONTHS.label} cost`,
        block1Value: ebsSnapshot1Cost,
        block1Unit: '$',
        block1ShowActionLink: 'SHOW',
        block1Icon: BLOCK_CONTAINER_ICON.SAVING,

        block2Label: `${EBS_SNAPSHOT_DURATION.SIX_MONTHS_TO_ONE_YEAR.label} cost`,
        block2Value: ebsSnapshot2Cost,
        block2Unit: '$',
        block2ShowActionLink: 'SHOW',
        block2Icon: BLOCK_CONTAINER_ICON.SAVING,

        block3Label: `${EBS_SNAPSHOT_DURATION.OVER_ONE_YEAR.label} cost`,
        block3Value: ebsSnapshot3Cost,
        block3Unit: '$',
        block3ShowActionLink: 'SHOW',
        block3Icon: BLOCK_CONTAINER_ICON.SAVING,

        block4Label: `Total cost`,
        block4Value: ebsSnapshotTotalCost,
        block4Unit: '$',
        block4ShowActionLink: 'SHOW',
        block4Icon: BLOCK_CONTAINER_ICON.SAVING,
      }))

      // Set default block values
    } else {
      setBlockContainersLabel(prev => ({
        ...prev,

        block1Label: 'Total Cost',
        block1Value: selectedTab === 'combined' ? totalCombinedCost : (selectedTab === 'custom' ? totalCustomCost : totalAWSCost),
        block1Unit: '$',
        block1Icon: BLOCK_CONTAINER_ICON.SAVING,

        block2Label: 'Total Recommended Saving Cost',
        block2Value: selectedTab === 'combined' ? totalCombinedSaving : (selectedTab === 'custom' ? totalCustomSaving : totalAWSSaving),
        block2Unit: '$',
        block2Icon: BLOCK_CONTAINER_ICON.SAVING,

        block3Label: 'Total Payable',
        block3Value: selectedTab === 'combined' ? totalCombinedRecommendedCost : (selectedTab === 'custom' ? totalCustomRecommendedCost : totalAWSRecommendedCost),
        block3Unit: '$',
        block3Icon: BLOCK_CONTAINER_ICON.SAVING,
      }))
    }
  }, [
    type,
    s3TotalStorage,
    asgHealthyCount,
    s3TotalObjects,
    asgUnhealthyCount,
    s3AverageObjectSize,
    asgRecommendedSaving,
    totalAWSSaving,
    totalAWSCost,
    totalAWSRecommendedCost,
    totalCombinedCost,
    totalCombinedRecommendedCost,
    totalCombinedSaving,
    totalCustomCost,
    totalCustomRecommendedCost,
    totalCustomSaving,
    ebsSnapshot1Cost,
    ebsSnapshot2Cost,
    ebsSnapshot3Cost,
    ebsSnapshotTotalCost,
    ebsTotalAvailable,
    selectedTab,
    asgHealthyCountAWS,
    asgUnhealthyCountAWS,
    asgRecommendedSavingAWS,
  ])

  useEffect(() => {
    if (selectedAccount) {
      fetchData()
      fetchOptimizationTagList()
    }
  }, [selectedAccount])

  useEffect(() => {
    if (filterList?.['tag'] === '' || (filterList?.['tag'] !== '' && filterList?.['values']?.length > 0)) {
      fetchData()
    }
  }, [filterList])

  /**
   * No data table overlay
   * @param {*} props 
   * @returns 
   */
  const SubscribeOverlay = (props) => {
    const [message, setMessage] = useState('')
    const [btnTitle, setBtnTitle] = useState('')
    const [showBtn, setShowBtn] = useState(false)

    useEffect(() => {
      if (loadingUserDetails === false && userDetails['subscriptionStatus'] && [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus'])) {
        setBtnTitle('')
        setShowBtn(false)
        setMessage((props['showCase'] && props['showCase'] === 'CUSTOM') ? 'No Custom Recommendation(s)' : `No ${type.toLocaleUpperCase()} Configured`)
      } else {
        setMessage('Your subscription is not active')
        setBtnTitle('Activate Now')
        setShowBtn(true)
      }
    }, [props])

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Typography
          variant="h6"
          color="textSecondary"
          className='activate-subscription-text'
        >
          {message}
          <br />
          {showBtn &&
            <Button
              variant="contained"
              size="small"
              className='activate-button'
              title='Click to activate'
              onClick={() => navigate(CONST_ROUTE_PATH.PRICING)}
            >
              {btnTitle}
            </Button>
          }
        </Typography>
      </Box>
    );
  }

  /**
   * HOC for Custom table in case of no data
   * @param {*} OverlayComponent 
   * @returns 
   */
  const noDataOverlayCustom = (OverlayComponent) => {
    return function NoDataOverlayComponent(props) {
      useEffect(() => {
        DebugService.log(`No Overlay Component: Props Changed`, props)
      }, [props])

      return <OverlayComponent showCase={'CUSTOM'} {...props} />
    }
  }

  /**
   * HOC for AWS table in case of no data
   * @param {*} OverlayComponent 
   * @returns 
   */
  const noDataOverlay = (OverlayComponent) => {
    return function NoDataOverlayComponent(props) {
      return <OverlayComponent showCase={'AWS'} {...props} />
    }
  }

  /**
   * @description Instant subscription activation handler
   */
  const activateSubscription = useCallback(() => {
    setSnackbarStatus(null)
    setSnackbarMessage(null)

    const userSubscriptionId = userDetails?.['userSubscriptionId']
    if (userSubscriptionId) {
      const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
      const parseToJson = JSON.parse(userDetails)

      const requestBody = {
        userId: parseToJson?.['userId'],
        accountId: parseToJson?.['userAccounts']?.[0]?.['accountId'],
        userSubscriptionId: userSubscriptionId
      }

      DebugService.log(`Optimization Component: Activate subscription request initiated`, requestBody)

      SubscriptionApiService.activateSubscription(requestBody)
        .then(res => {
          DebugService.log(`Optimization Component: Activate subscription response`, res)

          if (res['data']) {
            setSnackbarStatus('success')
            setSnackbarMessage(`${res['data']['message']}. Reload your page`)
            refetchUserDetails()
          } else {
            if (res['error']['code'] === 525) {
              setScopedItem(STORAGE_KEYS.CURRENT_ROUTE, CONST_ROUTE_PATH.PRICING)
              navigate(CONST_ROUTE_PATH.PRICING)
            } else {
              setSnackbarStatus('failed')
              setSnackbarMessage(res['error']['message'] ?? 'Subscription activation failed')
            }
          }
        })
        .catch(error => {
          DebugService.log(`Optimization Component: Plan purchase failed`, error)
          setSnackbarStatus('failed')
          setSnackbarMessage('Something went wrong')
        })
    }
  }, [userDetails])

  /**
   * @description Activate now element
   * @returns 
   */
  const activateNowEl = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          marginLeft: '1vw'
        }}
      >
        <Typography
          // variant='subtitle1'
          color={'#33adff'}
          style={{
            fontSize: '14px'
          }}
        >
          See only {TRIAL_SUBSCRIPTION_DATA_LIMIT} records?&nbsp;
          <Button
            variant="contained"
            size="small"
            // className='activate-button'
            title='Click to activate'
            onClick={() => setShowActivateNowConfirmModal(true)}
            style={{
              // color: '#ff6600',
              textTransform: 'none',
              padding: '3px',
              lineHeight: '1.2',
              backgroundColor: '#ff6600'
            }}
          >
            Activate Now
          </Button>
          {/* <Link className="navigate-link"
            title="Click to activate current subscription"
            // onClick={() => activateSubscription()}
            style={{
              // fontSize: '10px',
              // textDecoration: 'none',
              color: '#ff6600',
              fontWeight: '600'
            }}
            href="#">
            Activate Now
          </Link> */}
          &nbsp;to access full data.
        </Typography>
        {/* <Typography
          variant="h6"
          color="textSecondary"
        // className='activate-subscription-text'
        >
          <Link
            variant="contained"
            size="small"
            // className='activate-button'
            title='Click to activate'
            onClick={() => navigate(CONST_ROUTE_PATH.PRICING)}
          >
            Activate Now
          </Button>
        </Typography> */}
      </Box>
    )
  }

  /**
   * @description Activate now confirmation handler
   * @param {*} isConfirm 
   */
  const activateNowConfirmationHandler = (isConfirm) => {
    if (isConfirm) {
      activateSubscription()
    }

    setShowActivateNowConfirmModal(false)
  }

  /**
   * Reset block values
   */
  const resetBlockData = () => {
    setTotalAWSCost(0)
    setTotalAWSRecommendedCost(0)
    setTotalAWSSaving(0)
    setTotalCustomCost(0)
    setTotalCustomRecommendedCost(0)
    setTotalCustomSaving(0)

    setS3TotalStorage('')
    setS3TotalObjects('')
    setS3AverageObjectSize('')
  }

  const setBlockData = (totalPriceValues, isAWS) => {
    DebugService.log(`Optimization Component: Total price values for ${isAWS ? 'AWS' : 'CUSTOM'} ${type}`, totalPriceValues)

    if (isAWS === 'AWS') {
      if (['ec2', 'rds', 'ebs', 'elastic_ip'].includes(type.toLocaleLowerCase())) {
        setTotalAWSCost((totalPriceValues['currentCost'] ?? 0).toFixed(2))
        setTotalAWSRecommendedCost((totalPriceValues['recommendedCost'] ?? 0).toFixed(2))
        setTotalAWSSaving((totalPriceValues['savingCost'] ?? 0).toFixed(2))
      } else if (type.toLocaleLowerCase() === 's3') {
        setS3TotalStorage(totalPriceValues['totalStorage'] ?? '')
        setS3TotalObjects(totalPriceValues['totalObjects'] ?? '')
        setS3AverageObjectSize(totalPriceValues['averageObjectSize'] ?? '')
      } else if (type.toLocaleLowerCase() === 'asg') {
        setASGHealthyCountAWS(totalPriceValues['totalHealthyInstancesCount'] ?? '')
        setASGUnhealthyCountAWS(totalPriceValues['totalUnHealthyInstancesCount'] ?? '')
        setASGRecommendedSavingAWS(totalPriceValues['savingCost'] ?? 0)
      }
    } else if (isAWS === 'COMBINED') {
      setTotalCombinedCost((totalPriceValues['currentCost'] ?? 0).toFixed(2))
      setTotalCombinedRecommendedCost((totalPriceValues['recommendedCost'] ?? 0).toFixed(2))
      setTotalCombinedSaving((totalPriceValues['savingCost'] ?? 0).toFixed(2))
    } else {
      if (type.toLocaleLowerCase() === 'asg') {
        setASGHealthyCount(totalPriceValues['totalHealthyInstancesCount'] ?? '')
        setASGUnhealthyCount(totalPriceValues['totalUnHealthyInstancesCount'] ?? '')
        setASGRecommendedSaving(totalPriceValues['savingCost'] ?? 0)
      }
      // else if (type.toLocaleLowerCase() === 'elastic_ip') {
      //   const totalCost = (totalPriceValues['currentOnDemandMonthlyPriceValue'] ?? 0).toFixed(2)
      //   const recommendedCost = (totalPriceValues['recommendedOnDemandMonthlyPriceValue'] ?? 0).toFixed(2)

      //   setTotalAWSCost(totalCost)
      //   setTotalAWSRecommendedCost(recommendedCost)
      //   setTotalAWSSaving((totalCost - recommendedCost).toFixed(2))
      // }
      else if (['ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase())) {
        setEBSSnapshot1Cost((totalPriceValues['zeroToSixMonthsPriceValue'] ?? 0).toFixed(2))
        setEBSSnapshot2Cost((totalPriceValues['sixMonthsToOneYearPriceValue'] ?? 0).toFixed(2))
        setEBSSnapshot3Cost((totalPriceValues['overOneYearPriceValue'] ?? 0).toFixed(2))
        setEBSSnapshotTotalCost((totalPriceValues['totalCostValue'] ?? 0).toFixed(2))
      } else {
        setTotalCustomCost((totalPriceValues['currentCost'] ?? 0).toFixed(2))
        setTotalCustomRecommendedCost((totalPriceValues['recommendedCost'] ?? 0).toFixed(2))
        setTotalCustomSaving((totalPriceValues['savingCost'] ?? 0).toFixed(2))
      }
    }
  }

  /**
   * Fetch Recommendation data
   * @param {*} type 
   */
  const fetchData = () => {

    setIsLoading(true);
    setIsLoadingCustom(true);
    setIsLoadingCombined(true);

    setTableColumnList([])
    setTableRowList([])
    setCustomTableMasterData([])
    setTableColumnListCustom([])
    setTableRowListCustom([])
    setTableColumnListCombined([])
    setTableRowListCombined([])

    if (!['elastic_ip', 'ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase())) {
      OptimizationService.getTabularData(selectedAccount, type.toLocaleUpperCase())
        .then(data => {
          DebugService.log(`${type} tabular data`, data)
          setTableColumnList(data['columns'])

          let awsRowData = data['rows'] ?? []

          if ((userDetails['subscriptionStatus'] && [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus'])) || (getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS) && [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)))) {
            awsRowData = awsRowData.slice(0, TRIAL_SUBSCRIPTION_DATA_LIMIT)
          }

          setTableRowList(awsRowData)
        })
        .finally(() => {
          setTotalPriceValueAWS(OptimizationService.getTotalPriceValue() ?? {}, 'AWS')
          setBlockData(OptimizationService.getTotalPriceValue() ?? {}, 'AWS')
          setIsLoading(false)
        })
    } else {
      setIsLoading(false)
    }

    // Fetch Custom Recommendations
    if (['ec2', 'rds', 'ebs', 'asg', 'elastic_ip', 'ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase())) {
      let typeForAPI = type
      if (type === 'ebs-snapshot') {
        typeForAPI = 'ebs_snapshot'
      }
      else if (type === 'rds-snapshot') {
        typeForAPI = 'rds_snapshot'
      }

      DebugService.log(`Optimization Component: Fetching custom recommendation for CUSTOM_${type.toLocaleUpperCase()}`)
      OptimizationService.getTabularData(selectedAccount, `CUSTOM_${typeForAPI.toLocaleUpperCase()}`, filterList)
        .then(data => {
          DebugService.log(`CUSTOM_${type} tabular data`, data)
          setTableColumnListCustom(data['columns'])

          let awsCustomRowData = data['rows'] ?? []

          if ((userDetails['subscriptionStatus'] && [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus'])) || (getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS) && [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)))) {
            awsCustomRowData = awsCustomRowData.slice(0, TRIAL_SUBSCRIPTION_DATA_LIMIT)
          }

          if (type.toLocaleLowerCase() === 'ebs') {
            setEBSTotalAvailable(awsCustomRowData
              .filter(d => d['state'] === 'available')
              .reduce((sum, d) => sum + d['size'], 0))
          }

          setTableRowListCustom(awsCustomRowData)
          setCustomTableMasterData(awsCustomRowData)
        })
        .finally(() => {
          setTotalPriceValueCustom(OptimizationService.getTotalPriceValue() ?? {}, 'CUSTOM')
          setBlockData(OptimizationService.getTotalPriceValue() ?? {}, 'CUSTOM')
          setIsLoadingCustom(false)
        })
    } else {
      setTableColumnListCustom([])
      setTableRowListCustom([])
      setBlockData({}, 'CUSTOM')
      setIsLoadingCustom(false)
    }

    // Fetch Combined Recommendations
    if (['ec2', 'rds', 'ebs'].includes(type.toLocaleLowerCase())) {
      DebugService.log(`Optimization Component: Fetching combined recommendation for COMBINED_${type.toLocaleUpperCase()}`)
      OptimizationService.getTabularData(selectedAccount, `COMBINED_${type.toLocaleUpperCase()}`)
        .then(data => {
          DebugService.log(`COMBINED_${type} tabular data`, data)
          setTableColumnListCombined(data['columns'])

          let combinedRowData = data['rows'] ?? []

          if ((userDetails['subscriptionStatus'] && [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus'])) || (getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS) && [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)))) {
            combinedRowData = combinedRowData.slice(0, TRIAL_SUBSCRIPTION_DATA_LIMIT)
          }

          if (type.toLocaleLowerCase() === 'ebs') {
            setEBSTotalAvailable(combinedRowData
              .filter(d => d['state'] === 'available')
              .reduce((sum, d) => sum + d['size'], 0))
          }

          setTableRowListCombined(combinedRowData)
        })
        .finally(() => {
          setTotalPriceValueCombined(OptimizationService.getTotalPriceValue() ?? {}, 'COMBINED')
          setBlockData(OptimizationService.getTotalPriceValue() ?? {}, 'COMBINED')
          setIsLoadingCombined(false)
        })
    } else {
      setTableColumnListCombined([])
      setTableRowListCombined([])
      setBlockData({}, 'COMBINED')
      setIsLoadingCombined(false)
    }
  }

  /**
   * @description Filter snapshots for selected duration
   * @param {*} duration 
   */
  const snapshotViewDetailsHandler = (duration) => {
    DebugService.log('Optimization Component: Filtering snapshots for duration', duration, customTableMasterData)

    if ([
      EBS_SNAPSHOT_DURATION.ZERO_TO_SIX_MONTHS.value,
      EBS_SNAPSHOT_DURATION.SIX_MONTHS_TO_ONE_YEAR.value,
      EBS_SNAPSHOT_DURATION.OVER_ONE_YEAR.value,
    ].includes(duration)
      && customTableMasterData.length > 0) {
      setTableRowListCustom(customTableMasterData.filter(d => d['StartTimeEnum'] === duration))
    } else {
      if (duration !== 'ALL') {
        DebugService.warn('Optimization Component: Could\'nt filter snapshots because of invalid values', duration, customTableMasterData)
      }
      setTableRowListCustom(customTableMasterData)
    }
  }

  /**
   * @description Function to fetch filter tag list
   * @returns An array of tag/values list
   */
  const fetchOptimizationTagList = () => {
    DebugService.log('Optimization Component: Fetching filter tag list')

    setTagList([])
    setFilterList({ tag: '', values: [] })

    if (!selectedAccount) {
      return
    }

    let typeForAPI = type
    if (type === 'ebs-snapshot') {
      typeForAPI = 'ebs_snapshot'
    }
    else if (type === 'rds-snapshot') {
      typeForAPI = 'rds_snapshot'
    }
    else if (type === 'rds') {
      typeForAPI = 'RDS_DBINSTANCES'
    }

    const dataRequest = {
      type: typeForAPI.toLocaleUpperCase(),
      userAccountId: selectedAccount
    }

    InventoryApiService.getFilterTagList(APIConstants.ENDPOINT_AWS_FILTER_TAG, dataRequest)
      .then(res => {
        DebugService.log('Optimization Component: Filter tag list response', res)

        const apiTagList = res?.['data'] ?? []
        setTagList(apiTagList)
        setFilterList({ tag: '', values: [] })
      })
      .catch(err => {
        DebugService.error('Optimization Component: Error while fetching filter tag list', err)
      })
  }

  /**
   * @description Filter change handler
   * @param {*} field 
   * @param {*} value 
   * @returns void
   */
  const handleFilterChange = (field, value) => {
    if (field === 'tag') {
      const newTag = value ?? ''

      // When tag changes, reset values
      setFilterList({ tag: newTag, values: [] })
      return
    }

    if (field === 'values') {
      const values = typeof value === 'string' ? value.split(',') : (value ?? [])

      setFilterList(prev => ({
        tag: prev.tag,
        values: values
      }))
    }
  }

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Optimization`

    // Hide columns
    if (type?.toLocaleLowerCase() === 's3') {
      setDefaultHideColumns({
        BucketCreationDate: false,
        S3VersioningStatus: false,
        Region: false,
        TieringConfigurations: false
      })
    } else if (type?.toLocaleLowerCase() === 'rds') {
      // Hide columns
      setDefaultHideColumns({
        Region: false,
        dBInstanceIdentifier: false,
        dBInstanceStatus: false,
        engine: false,
        multiAZ: false,
        storageType: false,
        allocatedStorage: false,
        engineVersion: false,
        licenseModel: false,
        endpointAddress: false,
        instanceCreateTime: false,
        availabilityZone: false,
        publiclyAccessible: false,
        dBInstanceArn: false,
        dBClusterIdentifier: false,
        dbiResourceId: false,
        freeMemoryValue: false,
        freeStorageValue: false,
        averageCPUValue: false,
        peakCPUValue: false,
        sumOfConnectionsValue: false,
        totalMemory: false,
        usedMemoryPercentageValue: false,
        currentInstanceCostValue: false,
        currentInstanceMonthlyCostValue: false,
      })
    } else if (type?.toLocaleLowerCase() === 'ebs') {
      // Hide columns
      setDefaultHideColumns({
        rootVolume: false,
        volumeBaselineIOPS: false,
        volumeBaselineThroughput: false,
        volumeBurstIOPS: false,
        volumeBurstThroughput: false,
        volumeSize: false,
        volumeType: false,
        finding: false,
        lookBackPeriodInDays: false,
        id: false,
        region: false,
        VRO_performanceRisk: false,
        VRO_rank: false,
        state: false,
        attachmentIntanceIds: false,
        volumeType: false,
        snapshotId: false,
        throughput: false,
        createTime: false,
        availabilityZone: false,
        encrypted: false,
        multiAttachEnabled: false
      })
    } else if (type?.toLocaleLowerCase() === 'asg') {
      // Hide columns
      setDefaultHideColumns({
        Region: false,
        AutoScalingGroupARN: false,
        CreatedTime: false,
        ServiceLinkedRoleARN: false,
        DefaultCooldown: false,
        CapacityRebalance: false,
        HealthyInstancesCount: false,
        UnHealthyInstancesCount: false
      })
    } else {
      // Hide EC2 columns in custom table
      setDefaultHideColumns({
        region: false,
        ownerId: false,
        instanceId: false,
        privateIpAddress: false,
        stateName: false,
        platformDetails: false,
        launchTime: false,
        availabilityZone: false,
        usageOperation: false,
        instanceFamily: false,
        averageCPUValue: false,
        peakCPUValue: false,
        removeEventListenereservationId: false,
        vpcId: false,
        imageId: false,
        architecture: false,
        privateDnsName: false,
        publicDnsName: false,
        publicIpAddress: false,
        sumNetworkInByteValue: false,
        sumNetworkOutByteValue: false,
        vcpu: false,
        memory: false,
        finding: false,
        currentPerformanceRisk: false,
        findingReasonCodes: false,
        idle: false,
        instanceState: false,
        lookBackPeriodInDays: false,
        Recommendedrank: false,
        RecommendedprojectedUtilizationMetrics: false,
        currentVcpu: false,
        currentMemory: false,
      })
    }

    // Check for user subscription
    // checkAndNavigateToPrice(navigate)
  }, [])

  useEffect(() => {
    if (loadingUserDetails === false) {
      if (isSubscriptionActive === false) {
        DebugService.log(`Dashboard Component: Onboarded user is not subscribed`)
        navigate(CONST_ROUTE_PATH.PRICING)
      }

      DebugService.log('User Subscription Status', userDetails['subscriptionStatus'])
      if (userDetails['subscriptionStatus'] && [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus'])) {
        // Find tabular data
        try {
          setIsLoading(true)
          setIsLoadingCustom(true)
          setIsLoadingCombined(true)
          resetBlockData()

          if (type !== "") {
            if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
              fetchData()
            } else {
              window.addEventListener('userDetailsEvent', () => {
                fetchData()
              })
            }
          } else {
            DebugService.error('Optimization Component: Invalid type received', location.pathname)
          }
        } catch (e) {
          DebugService.error(`Optimization Component: Couldn't fetch data for current path ${location.pathname}`, e)
        } finally {

        }
      }
    }

  }, [loadingUserDetails, location.pathname])

  // useEffect(() => {
  //   if (filterList?.['tag'] !== '' && filterList?.['values']?.length > 0) {
  //     setSelectedTab('custom')
  //   }
  //   else if (tableRowListCombined.length > 0) {
  //     setSelectedTab('combined')
  //   }
  //   else if (tableRowListCustom.length > 0) {
  //     setSelectedTab('custom')
  //   }
  //   else if (tableRowList.length > 0) {
  //     setSelectedTab('aws')
  //   }
  // }, [tableRowList, tableRowListCustom, tableRowListCombined])

  /**
  * @description Stores the latest API response in storage.
  * @author Ashish Sharma
  */
  useEffect(() => {
      setScopedItem(STORAGE_KEYS.AI_CHATBOT_REQUEST_DATA,{
        combinedRecommendations: {
          tableRowListCombined,
          totalPriceValueCombined
        },
        cloudsAnalyticsRecommendations: {
          tableRowListCustom,
          totalPriceValueCustom
        },
        awsRecommendations: {
          tableRowList,
          totalPriceValueAWS
        }
      })
  },[tableRowList, totalPriceValueAWS, tableRowListCustom, totalPriceValueCustom, tableRowListCombined, totalPriceValueCombined])
  
  return (
    <Grid container spacing={3} className='optimization-page'>
      {/* Separate condition for "snapshot" is added for block alignment
            Otherwise all BlockContainer properties are handled for all Optimization types */}
      {['ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase()) && (
        <>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={1}
              displayIcon={blockContainersLabel.block1Icon}
              displayValue={blockContainersLabel.block1Value}
              displayLabel={blockContainersLabel.block1Label}
              unitValue={blockContainersLabel.block1Unit}
              showActionLink={blockContainersLabel.block1ShowActionLink}
              actionHandler={() => snapshotViewDetailsHandler(EBS_SNAPSHOT_DURATION.ZERO_TO_SIX_MONTHS.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={2}
              displayIcon={blockContainersLabel.block2Icon}
              displayValue={blockContainersLabel.block2Value}
              displayLabel={blockContainersLabel.block2Label}
              unitValue={blockContainersLabel.block2Unit}
              showActionLink={blockContainersLabel.block2ShowActionLink}
              actionHandler={() => snapshotViewDetailsHandler(EBS_SNAPSHOT_DURATION.SIX_MONTHS_TO_ONE_YEAR.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={3}
              displayIcon={blockContainersLabel.block3Icon}
              displayValue={blockContainersLabel.block3Value}
              displayLabel={blockContainersLabel.block3Label}
              unitValue={blockContainersLabel.block3Unit}
              showActionLink={blockContainersLabel.block3ShowActionLink}
              actionHandler={() => snapshotViewDetailsHandler(EBS_SNAPSHOT_DURATION.OVER_ONE_YEAR.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={4}
              displayIcon={blockContainersLabel.block4Icon}
              displayValue={blockContainersLabel.block4Value}
              displayLabel={blockContainersLabel.block4Label}
              unitValue={blockContainersLabel.block4Unit}
              showActionLink={blockContainersLabel.block4ShowActionLink}
              actionHandler={() => snapshotViewDetailsHandler('ALL')}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Typography color={'#808080'} variant="caption" style={{
              fontStyle: 'italic'
            }}><span style={{
              textDecoration: 'underline',
              fontWeight: '600'
            }}>Note</span>: All Cost has to be calculated on {type.toLocaleUpperCase()} size bases</Typography>
          </Grid>
        </>
      )}

      {type.toLocaleLowerCase() === 'ebs' && (
        <>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={1}
              displayIcon={blockContainersLabel.block1Icon}
              displayValue={blockContainersLabel.block1Value}
              displayLabel={blockContainersLabel.block1Label}
              unitValue={blockContainersLabel.block1Unit}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={2}
              displayIcon={blockContainersLabel.block2Icon}
              displayValue={blockContainersLabel.block2Value}
              displayLabel={blockContainersLabel.block2Label}
              unitValue={blockContainersLabel.block2Unit}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={3}
              displayIcon={blockContainersLabel.block3Icon}
              displayValue={blockContainersLabel.block3Value}
              displayLabel={blockContainersLabel.block3Label}
              unitValue={blockContainersLabel.block3Unit}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BlockContainer
              order={4}
              displayIcon={blockContainersLabel.block4Icon}
              displayValue={blockContainersLabel.block4Value}
              displayLabel={blockContainersLabel.block4Label}
              unitValue={blockContainersLabel.block4Unit}
            />
          </Grid>
        </>
      )}

      {!['ebs-snapshot', 'rds-snapshot', 'ebs'].includes(type.toLocaleLowerCase()) && (
        <>
          <Grid item xs={12} sm={6} lg={4}>
            <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
              <BlockContainer
                order={1}
                displayIcon={blockContainersLabel.block1Icon}
                displayValue={blockContainersLabel.block1Value}
                displayLabel={
                  ['ec2', 'rds'].includes(type.toLocaleLowerCase()) ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                      {blockContainersLabel.block1Label}
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'inline-flex',
                          cursor: 'pointer',
                          '&:hover .pricing-tooltip': {
                            display: 'block'
                          }
                        }}
                      >
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '14px',
                          height: '14px',
                          borderRadius: '50%',
                          border: '1.5px solid #506C84',
                          color: '#506C84',
                          fontSize: '9px',
                          fontWeight: 600,
                          lineHeight: 1,
                          userSelect: 'none'
                        }}>
                          i
                        </span>
                        <Box
                          className="pricing-tooltip"
                          sx={{
                            display: 'none',
                            position: 'absolute',
                            bottom: '20px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: '#333',
                            color: '#fff',
                            fontSize: '12px',
                            padding: '6px 10px',
                            borderRadius: '4px',
                            whiteSpace: 'nowrap',
                            zIndex: 999,
                            boxShadow: '0px 2px 6px rgba(0,0,0,0.3)'
                          }}
                        >
                          This pricing does not include savings plan discounts
                        </Box>
                      </Box>
                    </Box>
                  ) : blockContainersLabel.block1Label
                }
                unitValue={blockContainersLabel.block1Unit}
                showActionLink={blockContainersLabel.block1ShowActionLink}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <BlockContainer
              order={2}
              displayIcon={blockContainersLabel.block2Icon}
              displayValue={blockContainersLabel.block2Value}
              displayLabel={blockContainersLabel.block2Label}
              unitValue={blockContainersLabel.block2Unit}
              showActionLink={blockContainersLabel.block2ShowActionLink}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <BlockContainer
              order={3}
              displayIcon={blockContainersLabel.block3Icon}
              displayValue={blockContainersLabel.block3Value}
              displayLabel={blockContainersLabel.block3Label}
              unitValue={blockContainersLabel.block3Unit}
              showActionLink={blockContainersLabel.block3ShowActionLink}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <TabContext value={selectedTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={(e, currentTab) => setSelectedTab(currentTab)} aria-label="lab API tabs example">
              {['ec2', 'rds', 'ebs'].includes(type.toLocaleLowerCase()) &&
                <Tab label="Combined Recommendations" value="combined" className='tab' />
              }

              {!['ecs', 'lambda', 's3'].includes(type.toLocaleLowerCase()) && <Tab label={`${CONST_SITE_LABEL} Recommendations`} value="custom" className='tab' />}

              {!['elastic_ip', 'ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase()) && <Tab label="AWS Recommendations" value="aws" className='tab' />}
            </TabList>
          </Box>
          <TabPanel value="combined" className='tab-panel'>
            {/* Combined Recommendation */}
            {(['ec2', 'rds', 'ebs'].includes(type.toLocaleLowerCase())) && (
              <>
                {isLoadingCombined ? (
                  <TableLoader />
                ) : (
                  <>
                    {/* Tabular data view */}
                    <DataGridTable
                      evenRowBgColor={''}
                      headerBgColor={'#506C84'}
                      actionIconColor={'#506C84'}
                      evenRowColor={'#506C84'}
                      columns={tableColumnListCombined}
                      columnVisibilityModel={defaultHideColumns}
                      rows={tableRowListCombined}
                      showTooltip={showTableTooltip}
                      showPagination={!([SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus']) || [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)))}
                      subscribeOverlayComponent={noDataOverlayCustom(SubscribeOverlay)}
                      customFooterEl={([SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus']) || [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS))) && tableRowListCombined?.length === TRIAL_SUBSCRIPTION_DATA_LIMIT && activateNowEl()}
                    />
                  </>
                )}
              </>
            )}
          </TabPanel>

          <TabPanel value="custom" className='tab-panel'>
            {/* Custom Recommendation */}
            {(!['ecs', 'lambda', 's3'].includes(type.toLocaleLowerCase())) && (
              <>
                {isLoadingCustom ? (
                  <TableLoader />
                ) : (
                  <>
                    {/* Tabular data view */}
                    <Box className='optimization-filter-container'>
                      <FormControl
                        size="small"
                        className='optimization-filter-field'
                      >
                        <InputLabel id="optimization-filter-tag-label">Filter Tag</InputLabel>
                        <Select
                          labelId="optimization-filter-tag-label"
                          value={filterList.tag}
                          label="Filter Tag"
                          onChange={(event) => handleFilterChange('tag', event.target.value)}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {(tagList ?? []).map(tag => (
                            <MenuItem key={tag?.Key} value={tag?.Key}>
                              {tag?.Key}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl
                        size="small"
                        className='optimization-filter-field'
                        disabled={!filterList.tag}
                      >
                        <InputLabel id="optimization-filter-tag-values-label">Filter Tag Value</InputLabel>
                        <Select
                          labelId="optimization-filter-tag-values-label"
                          multiple
                          value={filterList.values}
                          onChange={(event) => handleFilterChange('values', event.target.value)}
                          input={<OutlinedInput label="Filter Tag Value" />}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => (
                                <Chip key={value} label={value} size="small" />
                              ))}
                            </Box>
                          )}
                        >
                          {((tagList ?? []).find(t => t?.Key === filterList.tag)?.Value ?? []).map(option => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                    <DataGridTable
                      evenRowBgColor={''}
                      headerBgColor={'#506C84'}
                      actionIconColor={'#506C84'}
                      evenRowColor={'#506C84'}
                      columns={tableColumnListCustom}
                      columnVisibilityModel={defaultHideColumns}
                      rows={tableRowListCustom}
                      showTooltip={showTableTooltip}
                      showPagination={!([SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus']) || [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)))}
                      subscribeOverlayComponent={noDataOverlayCustom(SubscribeOverlay)}
                      customFooterEl={([SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus']) || [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS))) && tableRowListCustom?.length === TRIAL_SUBSCRIPTION_DATA_LIMIT && activateNowEl()}
                    />
                  </>
                )}
              </>
            )}
          </TabPanel>

          <TabPanel value="aws" className='tab-panel'>
            {/* AWS Recommendation */}
            {(!['elastic_ip', 'ebs-snapshot', 'rds-snapshot'].includes(type.toLocaleLowerCase())) && (
              <>
                {isLoading ? (
                  <TableLoader />
                ) : (
                  <>
                    {/* Tabular data view */}
                    <DataGridTable
                      evenRowBgColor={''}
                      headerBgColor={'#506C84'}
                      actionIconColor={'#506C84'}
                      evenRowColor={'#506C84'}
                      columns={tableColumnList}
                      columnVisibilityModel={defaultHideColumns}
                      rows={tableRowList}
                      showTooltip={showTableTooltip}
                      showPagination={!([SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus']) || [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS)))}
                      subscribeOverlayComponent={noDataOverlay(SubscribeOverlay)}
                      customFooterEl={([SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(userDetails['subscriptionStatus']) || [SUBSCRIPTION_STATUS.TRIAL_ACTIVE].includes(getScopedItem(STORAGE_KEYS.SUBSCRIPTION_STATUS))) && tableRowList?.length === TRIAL_SUBSCRIPTION_DATA_LIMIT && activateNowEl()}
                    />
                  </>
                )}
              </>
            )}
          </TabPanel>
        </TabContext>
      </Grid>

      {/* Snackbar Notification */}
      {snackbarStatus && <SnackbarNotification
        initialOpen={true}
        duration={5000}
        message={snackbarMessage}
        actionButtonName={'Ok'}
        theme={snackbarStatus === 'success' ? SNACKBAR_THEME.GREEN : SNACKBAR_THEME.RED}
        yPosition={'top'}
        xPosition={'center'}
      />}

      {/* Confirm Modal */}
      {showActivateNowConfirmModal && <ConfirmModal
        open={true}
        headingLabel={'Activate Your Subscription!'}
        message={[
          <p>By clicking the button below, you’ll gain full access to premium features, exclusive content, and personalized recommendations.</p>,
          <br />
        ]}
        continueBtnLabel={'Proceed'}
        cancelBtnLabel={'Close'}
        onActionTaken={(isConfirm) => activateNowConfirmationHandler(isConfirm)}
      />}
    </Grid>
  );
}
